"use client";

import React, { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const statsData = [{
  value: 400,
  suffix: "%",
  label: "ROI GROWTH",
  description: "Average increase in operational efficiency for our AI-integrated partners."
}, {
  value: 120,
  suffix: "+",
  label: "STRATEGIES",
  description: "Bespoke digital transformation frameworks deployed globally this year."
}, {
  value: 15,
  suffix: "M",
  label: "CAPITAL MANAGED",
  description: "Strategic financial advisory for high-growth technology ventures."
}, {
  value: 98,
  suffix: "%",
  label: "RETENTION",
  description: "Client satisfaction rate across our premium consulting portfolio."
}];
const AnimatedNumber = ({
  value,
  isVisible
}: {
  value: number;
  isVisible: boolean;
}) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let startTime: number;
    const duration = 2000;
    const animate = (currentTime: number) => {
      if (!startTime) startTime = currentTime;
      const progress = Math.min((currentTime - startTime) / duration, 1);
      const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      setCount(Math.floor(easeProgress * value));
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setCount(value);
      }
    };
    requestAnimationFrame(animate);
  }, [value, isVisible]);
  return <>{count.toLocaleString()}</>;
};
export default function TheIntelligenceEdge() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="223893" id="the-intelligence-edge" className="relative py-24 overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1688832/img/digital_network_mesh.png)] bg-cover bg-center opacity-[0.05] pointer-events-none" aria-hidden="true" />
      
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background/90 to-secondary/10 pointer-events-none" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-4 tracking-tight">
            The Intelligence Edge
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Quantifiable excellence delivered through modern innovation and strategic AI solutions.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {statsData.map((stat, i) => <div data-index={i} key={i}>
              <Card className="h-full bg-card/60 backdrop-blur-xl border-white/10 shadow-lg hover:border-primary/50 transition-all duration-500 rounded-lg">
                <CardContent className="p-8 flex flex-col items-center text-center justify-center h-full">
                  <div className="text-4xl md:text-5xl font-bold font-mono text-primary mb-3 flex items-baseline drop-shadow-[0_0_15px_rgba(0,255,255,0.4)]">
                    <AnimatedNumber value={stat.value} isVisible={isVisible} />
                    <span>{stat.suffix}</span>
                  </div>
                  <h3 className="text-xs font-bold font-mono text-foreground mb-2 tracking-widest uppercase">
                    {stat.label}
                  </h3>
                  <p className="text-sm text-muted-foreground font-default leading-relaxed">
                    {stat.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-50" />
    </section>;
}